<template>
  <div id="page-text-fields">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <v-widget title="طرح‌های شما">
            <div slot="widget-content">
              <v-container>
                <v-layout wrap>
                  <v-btn flat block large class="success" @click="order('')" small>
                    سفارش جدید
                    &nbsp;
                    <v-icon color="text--secondary">keyboard_arrow_left</v-icon>
                  </v-btn>
                </v-layout>
                <v-layout wrap>
                  <v-flex
                    class="-mouse-pointer"
                    :key="art.id"
                    v-for="(art, _) in artworks"
                    xs12
                    md4
                  >
                    <v-card class="ma-2" style="text-align: center;overflow: hidden">
                      <img
                        :src="`/reseller_privates/extra_artworks/thumb_` + art.filename"
                        style="width: 150px;margin:0 auto;"
                      />
                      <v-divider></v-divider>
                      <v-card-actions>
                          <v-btn
                            flat
                            block
                            large
                            class="error"
                            small
                            @click="deleteArtworks(art.id)"
                          >
                            حذف {{art.name}}
                          </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </div>
          </v-widget>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container grid-list-xl fluid>
      <v-form @submit.prevent="handleSubmit" ref="form" lazy-validation>
        <v-layout row wrap>
          <v-flex sm12>
            <v-widget title="افزودن طرح جدید">
              <div slot="widget-content">
                <v-container>
                  <v-layout>
                    <v-flex>
                      <v-text-field
                        label="نام طرح"
                        name="name"
                        v-model="name"
                        type="text"
                        required
                        max-length="64"
                        :rules="[rules.required, rules.max64]"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex xs12>
                      <ImageSelect
                        v-model="picture"
                        label="تصویر"
                        format="jpg,png,JPG,PNG"
                        :height="480"
                        :width="480"
                        size-min
                        :max-size="30000"
                      ></ImageSelect>
                    </v-flex>
                  </v-layout>

                  <v-layout>
                    <div>
                      <v-btn
                        :loading="loading"
                        :disabled="loading"
                        color="green"
                        class="white--text"
                        large
                        type="submit"
                      >
                        ثبت &nbsp;
                        <v-icon left dark>save</v-icon>
                      </v-btn>
                    </div>
                  </v-layout>
                </v-container>
              </div>
            </v-widget>
          </v-flex>
        </v-layout>
      </v-form>
    </v-container>
    <v-snackbar
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :top="snackbar.y === 'top'"
      :bottom="snackbar.y === 'bottom'"
      :right="snackbar.x === 'right'"
      :left="snackbar.x === 'left'"
      :multi-line="snackbar.mode === 'multi-line'"
      :vertical="snackbar.mode === 'vertical'"
      v-model="snackbar.snackbar"
    >
      {{ snackbar.text }}
      <v-btn flat icon dark @click.native="snackbar.snackbar = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import VWidget from '@/components/VWidget';
import ImageSelect from '@/components/ImageSelect';
import HttpErrorToSnackbar from '@/api/HttpErrorToSnackbar';

export default {
  components: {
    VWidget,
    ImageSelect
  },
  data () {
    return {
      snackbar: {
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: 'multi-line',
        timeout: 6000,
        color: 'error',
        text: ''
      },
      name: '',
      picture: null,
      artworks: [],
      loader: null,
      loading: false,
      rules: {
        required: value => !!value || 'پر کردن این فیلد اجباری است.',
        max64: value =>
          value.length <= 64 || 'نام باید کوچکتر از ۶۴ کاراکتر باشد'
      }
    };
  },
  watch: {
    loader () {
      const l = this.loader;
      this[l] = !this[l];
      setTimeout(() => {
        this[l] = false;
      }, 1000);
      this.loader = null;
    }
  },
  mounted: function () {
    this.getArtworks();
  },
  methods: {
    getArtworks () {
      this.axios
        .get('/reseller/extra_artwork/')
        .then(response => {
          this.artworks = response.data.data;
        })
        .catch(error => {
          this.snackbar = HttpErrorToSnackbar(error);
        });
    },
    deleteArtworks (id) {
      this.DeleteEntityPromise('extra_artwork', id).then(() => {
        this.getArtworks();
      });
    },
    order (filename) {
      let win = window.open('/designer/?reseller=' + filename, '_blank');
      win.focus();
    },
    handleSubmit () {
      if (this.name === '') {
        this.snackbar.text = 'فیلد نام را پر کنید پر نمایید.';
        this.snackbar.y = 'top';
        this.snackbar.color = 'red';
        this.snackbar.snackbar = true;
        return;
      }
      if (this.picture === null) {
        this.snackbar.text = 'تصویر اجباری است.';
        this.snackbar.y = 'top';
        this.snackbar.color = 'red';
        this.snackbar.snackbar = true;
        return;
      }
      this.loader = 'loading';
      let formData = new FormData();
      formData.append('file', this.picture);

      this.axios
        .post(
          '/reseller/extra_artwork?name=' + encodeURI(this.name),
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )
        .then(() => {
          this.snackbar.text = 'با موفقیت انجام شد.';
          this.snackbar.y = 'bottom';
          this.snackbar.color = 'success';
          this.snackbar.snackbar = true;
          this.getArtworks();
        })
        .catch(() => {
          this.snackbar.text = 'ناتوان در ارسال تصاویر';
          this.snackbar.y = 'bottom';
          this.snackbar.color = 'error';
          this.snackbar.snackbar = true;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/extra_artworks/index.vue